import LegalLayout from "./LegalLayout"

export default function ConditionsCommande() {
  return (
    <LegalLayout>

      <h2>Commande</h2>
      <p>
        Les commandes sont effectuées via le site et transmises par email
        à la Friterie de Lalaing.
      </p>

      <h2>Validation</h2>
      <p>
        Une commande est considérée comme valide uniquement après réception
        par l’établissement.
      </p>

      <h2>Retrait</h2>
      <p>
        Les commandes sont à retirer sur place à l’adresse de la friterie.
        Aucun service de livraison n’est proposé.
      </p>

      <h2>Produits</h2>
      <p>
        Les produits peuvent contenir des allergènes. Les informations
        sont disponibles sur demande.
      </p>

      <h2>Disponibilité</h2>
      <p>
        En cas d’indisponibilité d’un produit, le client est contacté
        par téléphone ou SMS afin de convenir d’une alternative.
      </p>

      <h2>Boissons alcoolisées</h2>
      <p>
        La vente d’alcool est soumise à la législation belge en vigueur.
        La Friterie de Lalaing se réserve le droit de refuser une vente
        en cas de non-respect de cette réglementation.
      </p>

      <h2>Droit de rétractation</h2>
      <p>
        Conformément à la réglementation applicable aux biens périssables
        préparés à la demande, le droit de rétractation ne s’applique pas.
      </p>

    </LegalLayout>
  )
}